import React from 'react';
import { Typography, Button, Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import { Unit } from './Unit';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { toast } from '@livable/saas-react-components';
import { BackdropLoader } from '@livable/saas-react-components';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
export const BatchOccupancyUpdatesModalContent = observer(_ref => {
  let handleModalClose = _ref.handleModalClose;
  const store = useStore();
  const classes = useStyles();
  const modalFooterClasses = useModalFooterStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const handleSubmit = async () => {
    const data = {
      residencyModels: []
    };
    store.residenciesMultiActionStore.selectedDetails.map(i => {
      data.residencyModels.push({
        residencyId: i.id,
        occupancy: +i._newoccupancy
      });
    });
    const resp = await store.residencies.batchUpdateResidencyOccupancyAsync.run(data);
    if (resp && resp.isSuccessful) {
      var _store$homeDashboardS, _store$homeDashboardS2;
      toast('success', {
        body: [t('general.successfully_updated')]
      });
      store.residencies.toggleRefreshFlag(true);
      (_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.companyResidentsTabOptions) === null || _store$homeDashboardS === void 0 || _store$homeDashboardS.updateModel({
        refreshResidentsFlag: !((_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS2 !== void 0 && (_store$homeDashboardS2 = _store$homeDashboardS2.companyResidentsTabOptions) !== null && _store$homeDashboardS2 !== void 0 && _store$homeDashboardS2.refreshResidentsFlag)
      });
      store.residenciesMultiActionStore.deselectAll();
      handleModalClose();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.noPaddingTable
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    icon: false,
    size: "small",
    variant: "modal"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('residencies_page.keep_occupancy')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('residencies_page.occupancy_text'))), /*#__PURE__*/React.createElement("div", {
    className: classes.unitsList
  }, store.residenciesMultiActionStore.selectedDetails.map(i => {
    var _store$homeDashboardS3;
    return /*#__PURE__*/React.createElement(Unit, {
      key: i.id,
      id: i.id,
      propertyAddress: store.residenciesMultiActionStore.isSelectedIsMultiPropertyView && !store.residenciesMultiActionStore.isSelectedFromSingleProperty ? (_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS3 === void 0 || (_store$homeDashboardS3 = _store$homeDashboardS3.propertyDetails(i.propertyId).propertyInformation) === null || _store$homeDashboardS3 === void 0 || (_store$homeDashboardS3 = _store$homeDashboardS3.address) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.addressString : null
    });
  }))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleModalClose,
    'custom-attribute': '471-batch-occupancy-updates-modal'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    onClick: handleSubmit,
    disabled: store.residenciesMultiActionStore.selectedDetails.findIndex(i => i._newoccupancy.trim().length === 0) >= 0,
    'custom-attribute': '472-batch-occupancy-updates-modal'
  }, t('buttons.submit')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.residencies.updateResidencyOccupancyAsync.inProgress
  }));
});